// extracted by mini-css-extract-plugin
export default {"pm-casino-seo-content":"SEOWrapper__pm-casino-seo-content--slots-SXm3f"};